import { Link } from '@mui/material'
import React from 'react'

interface P {
    children?: JSX.Element | string | number | JSX.Element[]
    style?: React.CSSProperties
    onClick?: () => void
}

export default function TextLink({ children, style, onClick }: P) {
    const onLinkClick = (e: React.MouseEvent) => {
        e.preventDefault()
        e.stopPropagation()
        if (onClick) onClick()
    }

    return (
        <Link component='button' onClick={onLinkClick} style={{ ...style, justifyContent: 'flex-start' }}>
            {children}
        </Link>
    )
}
